export default "__VITE_ASSET__C5JpW2jc__"